import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-subscription-confirmation-dialog',
  templateUrl: './delete-subscription-confirmation-dialog.component.html',
  styleUrls: ['./delete-subscription-confirmation-dialog.component.scss']
})
export class DeleteSubscriptionConfirmationDialogComponent implements OnInit {

  text: string;
  
  constructor(
    public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    this.text = data ? `Sei sicuro di voler rimuovere definitivamente ${data}?` : 'Sei sicuro di voler rimuovere definitivamente il prodotto selezionato?';
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
